import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowConfig, WorkflowConfigType } from '@monorepo/interfaces';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkflowConfigService {
    private http = inject(HttpClient);
    private baseUrl = `${environment.apiConfig[0].uri}/workflow-config/`;

    public getWorkflowConfigs(type: WorkflowConfigType, filter?: string): Observable<WorkflowConfig[]> {
        let params = new HttpParams();
        if (filter) {
            params = params.set('filter', filter);
        }
        return this.http.get<WorkflowConfig[]>(`${this.baseUrl}${type}`, { params });
    }

    public getWorkflowConfig(type: WorkflowConfigType, configId: string): Observable<WorkflowConfig> {
        return this.http.get<WorkflowConfig>(`${this.baseUrl}${type}/${configId}`);
    }
}
